import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-with-free-text-reason-dialog',
  templateUrl: './confirm-with-free-text-reason-dialog.component.html',
  styleUrls: ['./confirm-with-free-text-reason-dialog.component.scss']
})
export class ConfirmWithFreeTextReasonDialogComponent implements OnInit {
  reasonText: string;

  reasons = [];

  constructor(
    public dialogRef: MatDialogRef<ConfirmWithFreeTextReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
  }

  cancelClicked() {
    this.dialogRef.close({ confirmButtonClicked: false, cancelButtonClicked: true });
  }

  confirmClicked() {
    this.dialogRef.close({ confirmButtonClicked: true, cancelButtonClicked: false, reasonText: this.reasonText });
  }

}
